module.exports = __webpack_public_path__ + "img/ticketech.7ce5a0b3.png";